/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useSortableComponentList } from "cms/components/hooks/use-sortable-component-list";
import { AddLineWithIcon } from "components/add-line-with-icon";
import PositionButtons from "components/position-buttons";
import RemoveIcon from "components/remove-icon";
import { SortableContent } from "components/sortable-content";
import { Fragment } from "react";
import { isArrayNotEmpty } from "utils/empty-exists";
import { Stack } from "@mui/material";
import { ComponentTimelineContext } from "./component-timeline-context";
import { ReactComponent as PlusRegularIcon } from "assets/images/icons/common/plus-regular-brand.svg";

const defaultTimeline = Object.freeze({
    title: "",
    description: {},
    image: {},
    link: {},
});

const TimelineComponentWrapper = (props) => {
    const { timelines: initialTimelines = [], onChangeList, children } = props;

    if (typeof onChangeList !== "function") {
        throw Error("onChangeList was not supplied, or is not a function");
    }

    const { list, sortableMethods, controls } = useSortableComponentList(
        initialTimelines,
        defaultTimeline,
        onChangeList
    );

    const { addNewItem, addNewItemBelow, removeItem, updateItems } = controls;

    return (
        <Fragment>
            <div className="simplicity-timeline-wrapper">
                <div className="timeline-section-header">
                    <div className="timeline-section-header-title">Milestones</div>
                    <div className="add-milestone" onClick={addNewItem}>
                        <div className="add-milestone-icon">
                            <PlusRegularIcon />
                        </div>
                        <div className="add-milestone-label">Add</div>
                    </div>
                </div>
                <Stack direction="column">
                    {isArrayNotEmpty(list) &&
                        list.map((item, index) => {
                            const { guid } = item;
                            const componentCarouselContext = {
                                list,
                                guid,
                                item,
                                index,
                                position: index,
                                addNewItem,
                                updateItems,
                                removeItem,
                            };
                            return (
                                <ComponentTimelineContext.Provider
                                    key={`timeline-${guid}`}
                                    value={componentCarouselContext}
                                >
                                    <SortableContent
                                        id={guid}
                                        index={index}
                                        sortableMethods={sortableMethods}
                                    >
                                        {children}

                                        <div>
                                            <PositionButtons
                                                index={index}
                                                list={list}
                                                handleUpdate={updateItems}
                                            />
                                            <RemoveIcon
                                                className="simplicity-composer-field-editor-remove"
                                                onDeleteItem={() => removeItem(index)}
                                                index={index}
                                            />
                                        </div>
                                    </SortableContent>
                                    <AddLineWithIcon addNewItem={() => addNewItemBelow(index)} />
                                </ComponentTimelineContext.Provider>
                            );
                        })}
                </Stack>
            </div>
        </Fragment>
    );
};
TimelineComponentWrapper.displayName = "TimelineComponentWrapper";
export { TimelineComponentWrapper };
